import { Button, Modal, Accordion, Row } from "react-bootstrap";
import { ReactComponent as IcCloseBanner } from "../../assets/images/ic_close_banner.svg"
import React, { useEffect, useState } from "react";
import SurgirCardPromotions from "components/ui/SurgirCardPromotions/SurgirCardPromotions";
import "./PromotionHistory.scss";
import SurgirBanner from "components/ui/SurgirBanner/SurgirBanner";
import ModalPromotions from "./components/ModalPromotions/ModalPromotions";
import { Container } from "react-bootstrap";
import { apiGetPromotions } from "service/apiEndPoint";
import Pagination from '@mui/material/Pagination';
import styled from "styled-components";
import bannerPartners from '../../assets/images/partners/Imagen banner  1080 x 785.png'
import { Card, Col, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import SurgirItemListWithIcon from "components/ui/SurgirItemListWithIcon/SurgirItemListWithIcon";
import SurgirListIcon from "components/ui/SurgirListIcon/SurgirListIcon";

import { ReactComponent as DownloadIcon } from './../../assets/images/Icons_descargar.svg'
import DownloadIconTab from '../../assets/images/Icons_descargar.svg'
const Chevron = 'images/transparency/transparency-chevron-right.svg'


const PromotionHistory: React.FC = () => {
  const location = useLocation();
  const [tabName, setTabName] = useState('home')
  useEffect(() => {
    const hash = location.hash.replace('#', '');

    if (hash === 'programas') {
      setTabName('programas');
    } else if (hash === 'contratos-y-tarifas') {
      setTabName('contratos-y-tarifas');
    } else if (hash === 'asamblea') {
      setTabName('asamblea');
    } else if (hash === 'preguntas-frecuentes') {
      setTabName('preguntas-frecuentes');
    } else if (hash === 'comunicados') {
      setTabName('comunicados');
    } else {
      setTabName('home');
    }
  }, [location.hash]);

  const [promotions, setPromotions] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0)
  const [selectedPage, setSelectedPage] = useState(1);

  const getPromotions = (payload: any) => {
    apiGetPromotions(payload).then((response) => {
      return response.json()
    })
      .then((data) => {
        setPromotions(data.data.result);
        setTotalPages(data.data.meta.totalPages)
        setSelectedPage(page);
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    const payload = {
      page: page,
      perPage: 6
    }
    getPromotions(payload);
  }, [page]);

  const handlePageChange = (event: any, value: any) => {
    setPage(value);
  };
  const [faqVisible, setFaqVisable] = useState(false)
  const [videosVisible, setVideosVisible] = useState(false)
  const [resultsVisible, setResultsVisible] = useState(false)
  const [visibleModalPromotion, setVisibleModalPromotion] = useState(false);
  const [titleModalPromotion, setTitleModalPromotion] = useState('')
  const [documentsModalPromotion, setDocumentsPromotion] = useState([])

  const handleModalPromotion = () => {
    setVisibleModalPromotion(false);
  };

  // Definir breakpoints
  const breakpoints = {
    small_max: '767px',
  };

  // Definir los estilos condicionales basados en los breakpoints
  const PaginationStyled = styled(Pagination)`
    margin: 48px auto;
    display: flex;
    justify-content: end;

    & .MuiPagination-ul li:first-child button::after {
      content: "Anterior";
      margin-left: 8px;
      position: relative;
      top: 35%;
      transform: translateY(-50%);
    }

    & .MuiPagination-ul li:last-child button::before {
      content: "Siguiente";
      margin-right: 8px;
      position: relative;
      top: 35%;
      transform: translateY(-50%);
    }

    @media (max-width: ${breakpoints.small_max}) {
      justify-content: center;

      & .MuiPagination-ul li:first-child button::after {
        content: none;
      }
  
      & .MuiPagination-ul li:last-child button::before {
        content: none;
      }
    }
  `;


  return (
    <div>


      <div className="boxi-partners" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner"> Zona de  <span style={{ color: "#EC0000" }}>Asociados </span><br />
                <span className="banner-subText-banner">Conoce el detalle de nuestro sistema.</span>
              </span>
            </div>
            <div>
              <img className="banner-image" src={bannerPartners} alt="Banner Asociados" fetchPriority='high' />
            </div>
          </div>
        </Container>

      </div>

      <Container>
        <div className="body-promotions">
          <div className="title-promotions">
            <span>¿Qué es un fondo Colectivo?</span>

          </div>
          <div className="parrafo">
            Los fondos colectivos son como una alcancía gigante en la que varias personas ponen dinero juntas. Cada mes, todos aportan un poco de dinero al fondo y se junta el suficiente dinero en la alcancía para que algunos del grupo compren su carro. Quienes pueden comprar cada vez se determina por sorteo, por lo que si sales ganador, ¡te llevas el carro de inmediato!
          </div>
          <br /><br /><br />
          <div className="title-promotions">
            <span>Información Importante </span>
          </div>
          <div className="parrafo">

            <Tabs
              activeKey={tabName}
              id="uncontrolled-tab-example"
              className="mb-5"
              onSelect={(key: any) => setTabName(key)}
              /*  onSelect={(key) => {
                 setTabName(key);
                 window.location.hash=key;
               }} */
              style={{ paddingLeft: "0", marginLeft: "8%", marginRight: "8%" }}
            >
              <Tab
                eventKey="home"
                title="Programas"
                style={{ marginLeft: "10%", marginRight: "10%", marginTop: -20 }}
              >

                <Row style={{ padding: 0 }}>
                  <Col md={4}>
                    <p className="Columna">
                      Programas
                    </p>
                  </Col>
                  <Col md={8}>


                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Caracteristicas Programa Santander 60
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PROGRAMA}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br /><Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Caracteristicas Programa Avanza
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PROGRAMA_AVANZA120}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Características Programa Avanza 120 VF 8abril26"} />
                        </div>
                      </div>
                    </Row>
                    <br /><Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Características Programa Súmate
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PROGRAMASUMATE}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Características Programa Planifica Más
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PLANIFICA}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                  </Col>
                </Row>

              </Tab>
              <Tab
                eventKey="asamblea"
                id="asamblea"
                title="Asambleas"
                style={{ marginLeft: "10%", marginRight: "10%", marginTop: -20 }}
              >

                <Row style={{ padding: 0 }}>
                  <Col md={4}>
                    <p className="Columna">
                      Transmisión</p>
                  </Col>
                  <Col md={8}>
                    <div style={{
                      position: 'relative',
                      overflow: 'hidden',
                      width: '100%',
                      paddingTop: '56.25%',
                    }}>
                      <iframe
                        src="https://reproplay.com/santanderlive/"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          width: '100%',
                          height: '100%',
                        }}
                        scrolling="no"
                        frameBorder="0"
                        allow="autoplay"
                        allowFullScreen
                        title="Asamblea Live"
                      ></iframe>
                    </div>
                    <br />
                    <div style={{ width: "100%" }}>
                      <button
                        type="button"
                        onClick={() => setVideosVisible(!videosVisible)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#EC0000',
                          cursor: 'pointer',
                          padding: 0,
                          textDecoration: 'underline'
                        }}
                      >
                        {videosVisible ? 'Ver menos videos ...' : 'Ver más videos '}
                      </button>
                    </div>
                    <br />
                    {/* Listado de Videos de Asamblea */}
                    {videosVisible && (
                      <>
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA17}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2026-08-05.mp4 </span>} downloadName={"Video Asamblea 5 de Agosto 2026"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA16}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea Santander 60 2026-07-07.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                       <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA15}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea Santander 120 2026-07-07.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA14}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea Santander 60 2026-06-04.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                       <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA13}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea Santander 120 2026-06-04.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA12}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2026-05-14.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA11}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2026-05-07.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-05-07"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA10}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2026-04-09.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-04-09"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA9}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2026-03-05.mp4 </span>} downloadName={"ST0001 - Asamblea 2026-03-05"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA8}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2026-02-12.mp4 </span>} downloadName={"Video Asamblea 12 de Febrero 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA7}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2026-02-05.mp4 </span>} downloadName={"Video Asamblea 5 de Febrero 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA6}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2026-01-15.mp4 </span>} downloadName={"Video Asamblea 15 de Enero 2026"} />
                        </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA5}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2026-01-08.mp4 </span>} downloadName={"Terminos"} />
                    </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA4}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2025-12-04.mp4 </span>} downloadName={"Terminos"} />
                    </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA3}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2025-11-04.mp4 </span>} downloadName={"Terminos"} />
                    </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA2}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea - 2025-10-14.mp4 </span>} downloadName={"Terminos"} />
                    </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_ASAMBLEA1}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Video Asamblea 2 G2 e Inaugural G3 - 2025-09-16.mp4 </span>} downloadName={"Terminos"} />
                    </div><br />
                    <div style={{ width: "90%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_VIDEO_INAUGURAL}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}>Video Inaugural G2 - 2025-08-14.mp4 </span>} downloadName={"Terminos"} />
                    </div><br /> <br />
                      </>
                    )}
                  </Col> <br />
                </Row>
                <Row style={{ padding: 0 }}>
                  <Col md={4}>
                    <p className="Columna">
                      Calendario</p>
                  </Col>
                  <Col md={8}>

                    <br />
                    <div className="card-style-transparence"  >
                      <div style={{ width: "100%" }}>
                        <span className="parrafo">
                          Calendario de Asambleas 

                        </span>
                      </div>
                      <div style={{ width: "40%" }}>
                        <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CALENDARIO_ASAMBLEA}
                          name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                      </div>
                    </div>
                    <br /> 
                     <br /> 
                  </Col>
                </Row>

                <Row style={{ padding: 0 }}>
                  <Col md={4}>
                    <p className="Columna">
                      Resultados</p>
                  </Col>
                  <Col md={8}>

                    <br /> <br />
                    <div className="card-style-transparence"  >
                      <div style={{ width: "100%" }}>
                        <span className="parrafo">
                          Resultado de la última asamblea
                          
                        </span>
                      </div>
                      <div style={{ width: "40%" }}>
                        <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ULTIMA_ASAMBLEA}
                          name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Resultados Asamblea 14 Mayo 2026"} />
                      </div>
                    </div><br /> 
                    <div style={{ width: "100%" }}>
                      <button
                        type="button"
                        onClick={() => setResultsVisible(!resultsVisible)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#EC0000',
                          cursor: 'pointer',
                          padding: 0,
                          textDecoration: 'underline'
                        }}
                      >
                        {resultsVisible ? 'Ver menos resultados ' : 'Ver más resultados '}
                      </button>
                    </div>
                    <br />
                    {resultsVisible && (
                      <>
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_16}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 05 de Agosto del 2026 </span>} downloadName={"Resultados Asamblea 5 de Agosto 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_AGOSTO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Agosto 2026 </span>} downloadName={"Ganador Sorteo Devolución Agosto 2026"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_15}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 07 de Julio del 2026 </span>} downloadName={"Resultados Asamblea 7 Mayo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_JULIO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Julio 2026 </span>} downloadName={"Ganador Sorteo Devolución Junio 2026"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_14}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 04 de Junio del 2026 </span>} downloadName={"Resultados Asamblea 7 Mayo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_JUNIO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Junio 2026 </span>} downloadName={"Ganador Sorteo Devolución Junio 2026"} />
                        </div><br />
                      <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_13}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 14 de Mayo del 2026 </span>} downloadName={"Resultados Asamblea 7 Mayo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_12}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 7 de Mayo del 2026 </span>} downloadName={"Resultados Asamblea 7 Mayo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_11}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 9 de Abril del 2026 </span>} downloadName={"Resultados Asamblea 9 Abril 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_10}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 5 de Marzo del 2026 </span>} downloadName={"Resultados Asamblea 5 Marzo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_MAYO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Mayo 2026 </span>} downloadName={"Ganador Sorteo Devolución Mayo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_ABRIL_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Abril 2026 </span>} downloadName={"Ganador Sorteo Devolución Abril 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_MARZO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Marzo 2026 </span>} downloadName={"Ganador Sorteo Devolución Marzo 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_FEBRERO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Febrero 2026 </span>} downloadName={"Ganador Sorteo Devolución Febrero 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_ENERO_2026}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Enero 2026 </span>} downloadName={"Ganador Sorteo Devolución Enero 2026"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_GANADOR_DEVOLUCION_DICIEMBRE_2025}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Ganador Sorteo Devolución Diciembre 2025 </span>} downloadName={"Ganador Sorteo Devolución Diciembre 2025"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_9}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 12 de Febrero del 2026 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_8}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 5 de Febrero del 2026 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_7}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 15 de Enero del 2026 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_6}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 8 de Enero del 2026 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_5}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 4 de Diciembre del 2025 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA_4}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 4 de Noviembre del 2025 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA3G2}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 14 de Octubre del 2025 - Grupo 2 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA3G3}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 14 de Octubre del 2025 - Grupo 3 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA3G4}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 14 de Octubre del 2025 - Grupo 4 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA2G3}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 16 de Setiembre del 2025 - Grupo 3 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA2_G2}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 16 de Setiembre del 2025 - Grupo 2 </span>} downloadName={"Terminos"} />
                        </div><br />
                        <div style={{ width: "90%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RESULTADOS_ASAMBLEA1}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Resultados de Asamblea 14 de Agosto del 2025 </span>} downloadName={"Terminos"} />
                        </div><br />
                      </>
                    )}
                  </Col>
                </Row>

              </Tab>
              <Tab
                eventKey="contratos-y-tarifas"
                id="contratos-y-tarifas"
                title="Contratos y Tarifas"
                style={{ marginLeft: "10%", marginRight: "10%", marginTop: -20 }}
              >
                <Row>
                  <Col md={4}>
                    <p className="Columna">
                      Documentos

                    </p>
                  </Col>
                  <Col md={8}>

                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Contrato Programa Santander 60
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CONTRATO_SANTANDER60}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                      <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Contrato Programa Planifica Más
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CONTRATO_PLANIFICA}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Modelo Contrato Programa Avanza120
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CONTRATO_AVANZA120}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Modelo Contrato Programa Avanza120 VF 8Abril26"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                           RIGSE Autorización programa Santander Avanza 120
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RIGSE_AVANZA120}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"RIGSE Autorización programa Santander Avanza 120"} />
                        </div>
                      </div>
                    </Row><br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                           RIGSE Autorización programa Planifica Más
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RIGSE_PLANIFICA }
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"RIGSE Autorización programa Santander Avanza 120"} />
                        </div>
                      </div>
                    </Row>
                    <br />

                    <br />

                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Contrato Programa Súmate
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CONTRATO_PROGRAMASUMATE}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            Tarifario
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_TARIFARIO}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <br /> <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                            RIGSE 163-2025-SMV/10.2
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_RIGSE163}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <br />
                     <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                             Formato PEP
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_PEP}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                     <br />
                      <Row style={{ marginTop: 10 }}>
                        <div className="card-style-transparence"  >
                          <div style={{ width: "100%" }}>
                            <span className="parrafo">
                              ACTUALIZACIÓN DE IMPORTES
                            </span>
                          </div>
                          <div style={{ width: "40%" }}>
                            <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_ACTUALIZACION_IMPORTES}
                              name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"ACTUALIZACIÓN DE IMPORTES"} />
                          </div>
                        </div>
                      </Row>
                    <br />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <p className="Columna">
                      Firma Digital de Documentos

                    </p>
                  </Col>
                  <Col md={8}>

                    <Row style={{ marginTop: 10 }}>
                      <a target="blank" href="    https://firma.sistemaffcc.com/">click aquí.</a>


                    </Row>
                    <br />

                    <br />
                  </Col>
                </Row>


              </Tab>


              <Tab
                eventKey="comunicados"
                title="Comunicados"
                style={{ marginLeft: "10%", marginRight: "10%", marginTop: -20 }}
              >
                <Row style={{ padding: 0 }}>
                  <Col md={4}>
                    <p className="Columna">Avisos</p>
                  </Col>
                  <Col md={8}>
                  <div className="card-style-transparence">
                      <div style={{ width: "100%" }}>
                        <span className="parrafo">
                          Agosto 2026 - Cambio de horario de las Asambleas del Programa Santander 60
                        </span>
                      </div>
                      <div style={{ width: "40%" }}>
                        <SurgirItemListWithIcon
                          icon={DownloadIconTab}
                          document={process.env.REACT_APP_COMUNICADO_SANTANDER60_3}
                          name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>}
                          downloadName={"Agosto 2026 - Cambio de horario de las Asambleas"}
                        />
                      </div>
                    </div> <br />
                    <div className="card-style-transparence">
                      <div style={{ width: "100%" }}>
                        <span className="parrafo">
                          Modificación del Programa Santander Tradicional, ahora es SANTANDER 60. Conoce las
                          <span
                            className="linkrojo"
                            style={{ color: '#EC0000', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => setTabName('home')}
                          >
                            {' '}Características del Programa
                          </span>{' '}y{' '}
                          <span
                            className="linkrojo"
                            style={{ color: '#EC0000', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => setTabName('contratos-y-tarifas')}
                          >
                            modelo de Contrato.
                          </span>
                        </span>
                      </div>
                    </div>
                    <br />
                    
{/*  
                  <span className="parrafo">
                         
                          </span>Modificación del Programa Santander Tradicional, ahora es SANTANDER 60. Conoce las Características del Programa  y modelo de Contrato, Aquí.
                          <br/>
                  <Row style={{ marginTop: 30 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                          Caracteristicas Programa Santander 60
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PROGRAMA}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div><br/>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                          Características Programa Súmate
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CARACTERISTICAS_PROGRAMASUMATE}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                    <br />
                    <Row style={{ marginTop: 10 }}>
                      <div className="card-style-transparence"  >
                        <div style={{ width: "100%" }}>
                          <span className="parrafo">
                          Contrato Programa Santander 60 
                          </span>
                        </div>
                        <div style={{ width: "40%" }}>
                          <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_CONTRATO_SANTANDER60}
                            name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                        </div>
                      </div>
                    </Row>
                     */}
                  </Col>
                </Row>
              </Tab>

              <Tab
                eventKey="preguntas-frecuentes"
                title="Preguntas Frecuentes"
                style={{ marginLeft: "10%", marginRight: "10%", marginTop: -20 }}
              >
                <div className="section-information__tabs">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        ¿Qué es un Sistema de Administración de Fondo Colectivo?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es una modalidad que permite a las personas naturales y/o jurídicas participar de un fondo colectivo a través de sus aportes periódicos en dinero (cuotas mensuales), con la finalidad de adquirir bienes (inmuebles, automóviles, motos, maquinaria y equipo) y/o servicios que autorice la Superintendencia del Mercado de Valores (SMV).
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        ¿Qué es un Programa?
                      </Accordion.Header>
                      <Accordion.Body>
                        Los Programas contienen información relevante para el Asociado acerca del marco general y las características aplicables a los Grupos formados (los grupos están conformados por un número determinado de Asociados que participan de un fondo colectivo, en virtud de sus contratos). Deben ser presentados a la SMV para su autorización.
                        <br />Los Programas deben estar a disposición del público en general, siendo obligación de las Empresas Administradoras de Fondos Colectivos (EAFC) difundirlos permanentemente a través de su página web.
                        <br />Dentro de la información relevante que debe incorporar el programa, cabe mencionar la siguiente:

                        <ul>
                          <li>• Las modalidades para la adquisición de los bienes y/o servicios.</li>
                          <li>• La descripción de los bienes y/o servicios que serán adquiridos para los Asociados que integren los grupos que se formen bajo el Programa.</li>
                          <li>• El plazo de duración del Grupo y la periodicidad de las Asambleas.</li>
                          <li>• El número teórico de Asociados que conformarán el Grupo y el número de adjudicaciones por Asamblea.</li>
                          <li>• El porcentaje y periodicidad de cobro de las cuotas de inscripción, administración y capital.</li>
                          <li>• La política de garantías (la política de garantías debe especificar las garantías reales y personales que serán admitidas por la EAFC, así como la cobertura mínima respecto del monto adeudado por el Asociado) y las causales para su ejecución.</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        ¿Qué es un Contrato?
                      </Accordion.Header>
                      <Accordion.Body>
                        El Contrato de Administración de Fondos Colectivos regula las relaciones entre los Asociados y las EAFC, precisando los deberes y obligaciones de ambas partes. El(los) modelo(s) de contrato(s) que utilizará(n) la EAFC debe(n) ser presentado(s) a la SMV juntamente con la solicitud de autorización del(los) Programa(s) correspondiente(s). Dentro de la información relevante que debe incorporar el Contrato, cabe mencionar la siguiente:
                        <ul>
                          <li>• Las características del Programa bajo el cual se conforma el Grupo.</li>
                          <li>• Las modalidades y procedimientos de adjudicación.</li>
                          <li>•	Las características principales de los bienes o servicios que podrán ser adquiridos en el marco del Contrato, y los requisitos y plazos para su entrega. </li>
                          <li>• Las garantías y seguros que se exigirán al Asociado para la entrega del bien y/o la prestación del servicio adjudicado.</li>
                          <li>• El detalle de las cuotas y gastos que debe abonar el Asociado.</li>
                          <li>• Medidas ante el incumplimiento de pagos.</li>
                          <li>• Causales de resolución del Contrato.</li>
                          <li>• Las condiciones para la cesión de posición contractual.</li>
                          <li>• Las penalidades que se pacten.</li>
                          <li>• Cláusula mediante la cual el Asociado declara su sometimiento a las normas que dicte la SMV.</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        ¿Qué es la Cartilla para el Asociado?
                      </Accordion.Header>
                      <Accordion.Body>
                        La Cartilla para el Asociado describe en términos sencillos los aspectos más importantes de un Sistema de Fondos Colectivos. En este ámbito, Las EAFC tienen la obligación de entregar la Cartilla a los potenciales Asociados con anterioridad a su firma del Contrato de administración de fondos colectivos, la Cartilla explica en un formato de preguntas y respuestas:
                        <ul>
                          <li>• ¿Qué es un Sistema de Fondos Colectivos?</li>
                          <li>• ¿Cómo se adquiere la calidad de Asociado?</li>
                          <li>• ¿Qué pagos efectúa el Asociado a la EAFC por el servicio que le brinda?</li>
                          <li>• ¿Cómo se adquiere el derecho de adjudicación?</li>
                          <li>• ¿Cuál es la condición para la entrega del bien y/o servicio adjudicado?</li>
                          <li>• ¿Qué sucede si el Asociado incumple con los pagos de las cuotas establecidas en el Contrato? </li>
                          <li>• ¿Quién supervisa y controla a las EAFC?</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        ¿Qué incorpora el Tarifario?
                      </Accordion.Header>
                      <Accordion.Body>
                        En el tarifario se incorporan los cobros de las EAFC por los servicios adicionales que brindan a los Asociados, distintos de los cubiertos por la cuota de Ad-ministración o por la cuota de Inscripción.
                        <br />Las EAFC tienen la obligación de entregar el tarifario a los potenciales Asociados con anterioridad a su firma del Contrato de Administración de Fondos Colectivos. Sin perjuicio de ello, deberán exhibirse en lugares visibles y estar a disposición del público en general en las oficinas de las EAFC en folletos u hojas impresas.

                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        ¿Qué es un Certificado de compra?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es un documento que representa el derecho del Asociado a la aplicación del importe que se consigna en él para la adquisición del bien y/o servicio.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        ¿Qué es la Cuota de Inscripción?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es el importe que el Asociado paga por única vez a la EAFC por el derecho de ingreso a un Grupo y por cada Contrato del que sea titular.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                        ¿Qué es la Cuota Total?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es el importe que el Asociado paga de forma periódica a la EAFC y que comprende, a su vez, los siguientes conceptos:
                        <ul>
                          <li>• Cuota Capital: Monto destinado exclusivamente a cubrir el valor del bien y/o servicio materia del Contrato.</li>
                          <li>• Cuota de Administración: Monto que se paga a las EAFC por el servicio de administración de Fondos Colectivos.</li>
                          <li>• Cuota de Seguro: Monto que se paga por seguro de desgravamen, seguro de vida o cualquier otro riesgo asegurable vinculado al Contrato, como el seguro vehicular, siempre que el Programa y el Contrato lo hayan establecido.</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                        ¿Qué incorpora un Estado de Cuenta?
                      </Accordion.Header>
                      <Accordion.Body>
                        La información mínima que debe incorporar el Estado de Cuenta es la siguiente:
                        <ul>
                          <li>• El valor del certificado de compra o bien y/o servicio determinado objeto del Contrato.</li>
                          <li>• Fecha de la Asamblea Inaugural.</li>
                          <li>• Fecha proyectada de finalización de grupo.</li>
                          <li>• Número de cuotas a pagar, monto de la cuota mensual y número de cuotas pendientes de pago.</li>
                          <li>• Estado y fecha de adjudicación.</li>
                          <li>• Detalle de los pagos de cuotas.</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="9">
                      <Accordion.Header>
                        ¿Quién convoca a una Asamblea?
                      </Accordion.Header>
                      <Accordion.Body>
                        Las Asambleas son convocadas por la Administradora y se realizan con la participación de un notario a fin de adjudicar a los Asociados hábiles con Contratos no Adjudicados y, cuando corresponda, sortear la devolución de aportes a los Asociados con Contratos resueltos.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        ¿Qué es una Adjudicación?
                      </Accordion.Header>
                      <Accordion.Body>
                        La adjudicación es el mecanismo a través del cual el Asociado accede al derecho de obtener un bien y/o servicio o a un certificado de compra que será utilizado para la adquisición de un bien y/o servicio.<br /> Las adjudicaciones se dan en cada Asamblea y son de los siguientes tipos:
                        <ul>
                          <li>• Adjudicación por sorteo</li>
                          <li>• Adjudicación por remate</li>
                          <li>• Adjudicación anticipada</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        ¿Cómo se adquiere el derecho de Adjudicación?
                      </Accordion.Header>
                      <Accordion.Body>
                        Los asociados para ser adjudicados, es decir, acceder al derecho de adquisición del bien y/o servicio objeto del Contrato, deben estar al día en el pago de las cuotas, tener un contrato que aún no haya sido adjudicado y no encontrarse inhabilitado de acuerdo con lo establecido en el Contrato.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="12">
                      <Accordion.Header>
                        ¿Qué es una adjudicación por Sorteo?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es el mecanismo por el cual se elige al azar al Asociado que será adjudicado.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="13">
                      <Accordion.Header>
                        ¿Qué es una adjudicación por Remate?
                      </Accordion.Header>
                      <Accordion.Body>
                        El Remate es la modalidad de adjudicación que consiste en formular propuestas de pago por adelantado de un número determinado y entero de Cuotas Capital o Cuotas Total.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="14">
                      <Accordion.Header>
                        ¿Qué es una Adjudicación Anticipada?
                      </Accordion.Header>
                      <Accordion.Body>
                        Es un mecanismo por el cual se pueden efectuar adjudicaciones anticipadas de Certificados de Compra o bienes y/o servicios determinados. Para tal efecto, la Administradora, y/o su proveedor, otorgarán un financiamiento complementario significativo al Grupo, el mismo que podrá ser en bienes, servicios o en efectivo. Los intereses o gastos por dicho financiamiento no serán asumidos por el Fondo Colectivo ni por los asociados.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="15">
                      <Accordion.Header>
                        ¿Cómo presento mi remate?
                      </Accordion.Header>
                      <Accordion.Body>
                        La propuesta de remate se registra a través de nuestra página web en la sección Propuesta de Remates. Tendrás que ingresar tus datos y podrás formular el adelanto de cuotas que prefieras. Esta propuesta será develada el día de tu asamblea con presencia de notario público.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="16">
                      <Accordion.Header>
                        ¿Cuántas cuotas debo rematar para adjudicar?
                      </Accordion.Header>
                      <Accordion.Body>
                        La oferta es totalmente libre, no hay ni un mínimo ni un máximo requerido, ganan las más altas (quien adelante más cuotas), por lo que nadie puede asegurarle la adjudicación con un determinado número de cuotas.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="17">
                      <Accordion.Header>
                        ¿Cómo me entero de que salí adjudicado?
                      </Accordion.Header>
                      <Accordion.Body>
                        Los resultados son publicados en la página web de Santander, luego de 24 horas de haberse llevado a cabo la asamblea.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="18">
                      <Accordion.Header>
                        ¿Qué debo hacer cuando salga adjudicado?
                      </Accordion.Header>
                      <Accordion.Body>
                        Puedes comunicarte a nuestro número de Atención al Cliente (01) 730 - 1077 para solicitar más información o espera recibir el correo electrónico por parte de la administradora, donde te indicarán los documentos requeridos para iniciar el proceso de adjudicación.
                      </Accordion.Body>
                    </Accordion.Item>



                    {
                      !faqVisible ? (
                        <div className="section-information_tabs_link">
                          <div className="section-information__tabs__link__body" onClick={() => setFaqVisable(true)} >
                            <h6  >Ver más preguntas</h6>
                            <span>
                              <img src="icons/safe/chevron-down-sm.svg" alt="Place Holder" />
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <Accordion.Item eventKey="19">
                            <Accordion.Header>
                              ¿Con qué marcas de autos trabajan?
                            </Accordion.Header>
                            <Accordion.Body>
                              Trabajamos con todas las marcas, tenemos convenios con las marcas y dealers, quienes brindarán las características y precios del vehículo que elijas.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="20">
                            <Accordion.Header>
                              ¿Puedo adquirir un auto de mayor valor?
                            </Accordion.Header>
                            <Accordion.Body>
                              Sí se puede, existen dos opciones: una es ampliar el certificado antes de lograr la adjudicación, y la otra es pagar la diferencia al concesionario después de adjudicar.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="21">
                            <Accordion.Header>
                              ¿Luego de salir adjudicado, en cuánto tiempo me entregan el auto?
                            </Accordion.Header>
                            <Accordion.Body>
                              El plazo de entrega dependerá del concesionario donde se adquiera el vehículo y de que se cuente con todos los documentos requeridos.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="22">
                            <Accordion.Header>
                              ¿Qué documentos debo firmar para convertirme en Asociado?
                            </Accordion.Header>
                            <Accordion.Body>
                              <ul>
                                <li>• Características del Programa</li>
                                <li>• Contrato de Administración de Fondos Colectivos</li>
                                <li>• Solicitud de ingreso al Programa</li>
                                <li>• Cartilla para el Asociado</li>
                                <li>• Cronograma de Pagos</li>
                                <li>• Tarifario</li>
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="23">
                            <Accordion.Header>
                              ¿Cómo puedo participar en las Asambleas?
                            </Accordion.Header>
                            <Accordion.Body>
                              Para participar debes encontrarte al día en el pago de tus cuotas y penalidades hasta un (01) día antes de la fecha de la Asamblea de tu Grupo, el no estar al día en el pago implica que no podrás participar en los sorteos y remates que se realicen en ella.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="24">
                            <Accordion.Header>
                              ¿Cómo puedo pagar la Cuota de Inscripción?
                            </Accordion.Header>
                            <Accordion.Body>
                              Puedes realizar el pago mediante el enlace de pago de IZIPAY que te será enviado desde el correo electrónico comunicacionesasociados@santanderffcc.com.pe
                              <br />También puedes realizarlo desde nuestra página web en la sección  <a
                                href="https://app-fondoscolectivos-pago-test.azurewebsites.net/#/login  "
                                target="_blank"
                                className="linkturquesa "
                                rel="noopener noreferrer"
                              >
                                Pago de Cuotas
                              </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="25">
                            <Accordion.Header>
                              ¿Cómo puedo pagar mis cuotas?
                            </Accordion.Header>
                            <Accordion.Body>
                              La primera cuota la debes realizar mediante el enlace de pago de IZIPAY que te será enviado por correo electrónico.
                              <br />Las siguientes cuotas las podrás realizar desde la ventanilla o la app del banco con los que tenemos convenio usando el servicio de recaudación de “Santander Fondos Colectivos” y tu código identificador (número de operación). La relación de dichos bancos la podrás revisar en la sección de  <a
                                href="/transparencia "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Transparencia                     </a>
                              de la web.
                              <br />También puedes realizar el pago desde nuestra página web, en la sección  <a
                                href="https://app-fondoscolectivos-pago-test.azurewebsites.net/#/login "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Pago de Cuotas
                              </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="26">
                            <Accordion.Header>
                              ¿Qué pasa si salgo como Suplente?
                            </Accordion.Header>
                            <Accordion.Body>
                              Los Asociados que hayan presentado su propuesta de remate en la Asamblea y no hayan sido adjudicados, pero que obtengan las propuestas más faltas quedarán como suplentes en caso de que alguno de los Asociados adjudicados titulares no complete el pago del remate en el plazo establecido.
                              <br />El orden de preferencia se determinará por el mayor número de cuotas rematadas
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="27">
                            <Accordion.Header>
                              ¿Cómo elijo mi vehículo?
                            </Accordion.Header>
                            <Accordion.Body>
                              El Asociado deberá comunicar a la EAFC la elección del bien y/o servicio de acuerdo con lo establecido en el Programa y en su Contrato. Además, deberá indicar el nombre del proveedor elegido, precio final y las características del bien y/o servicio a adquirir.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="28">
                            <Accordion.Header>
                              ¿Qué es un Aval?
                            </Accordion.Header>
                            <Accordion.Body>
                              Es una garantía personal, un aval es un respaldo que una persona concede a otra con el fin de asegurar el cumplimiento de una obligación financiera o contractual. Se establece que, si la persona que ha asumido el compromiso legal no puede cumplir con sus obligaciones, el avalista asumirá la responsabilidad.          </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="29">
                            <Accordion.Header>
                              ¿Qué sucede si el vehículo que elijo es de mayor valor que mi Certificado?
                            </Accordion.Header>
                            <Accordion.Body>
                              Cuando el valor del bien y/o servicio sea mayor que el valor del Certificado de Compra, el Asociado debe cubrir la diferencia.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="30">
                            <Accordion.Header>
                              ¿Qué sucede si el vehículo que elijo es de menor valor que mi Certificado?
                            </Accordion.Header>
                            <Accordion.Body>
                              Cuando el valor del bien adjudicado sea menor al Certificado de Compra, a elección del asociado, la diferencia se aplicará a:
                              <ul>
                                <li>• Cancelar las últimas cuotas pendientes de pago.</li>
                                <li>•	Reducir el importe de las Cuota Total. Esta reducción es el resultado de dividir el monto de la diferencia entre el valor del Certificado de Compra o el valor del bien determinado y el bien y/o servicio adquirido, entre el número total de cuotas pendientes de pago.</li>
                                <li>•	Pagar las cuotas devengadas al cubrir una vacante.</li>
                                <li>•	Cubrir los gastos para mejoras del bien y/o servicio hasta un máximo del diez por ciento (10%) del valor del Certificado de Compra o al valor del bien a la suscripción del Contrato.</li>
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="31">
                            <Accordion.Header>
                              ¿Qué documentos debo firmar una vez adjudicado?
                            </Accordion.Header>
                            <Accordion.Body>
                              <ul>
                                <li>• Comunicación de Adjudicación y Requisitos</li>
                                <li>• Contrato de Garantía Mobiliaria</li>
                                <li>• Escritura Pública de Constitución de Garantía Mobiliaria</li>
                                <li>• Pagaré</li>
                                <li>• Declaración Personal de Salud (DPS)</li>
                                <li>• Declaración Jurada de Uso de Vehículo</li>
                                <li>• Declaración Jurada de Licitud de Fondos</li>
                                <li>• Proforma de Seguro Vehicular</li>
                                <li>• Formato GPS</li>
                                <li>• Formato de Protección de Datos Personales</li>
                                <li>• Resumen Informativo</li>
                                <li>• Cronograma actualizado</li>
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="32">
                            <Accordion.Header>
                              ¿Cuál es la ventaja de tener mi seguro de auto incluido en la cuota?
                            </Accordion.Header>
                            <Accordion.Body>
                              <ul>
                                <li>• Tu auto siempre estará protegido durante la vigencia de tu Certificado.</li>
                                <li>• Cuentas con el respaldo de las principales aseguradoras del país.</li>
                                <li>•	En caso de robo, al tener un seguro auto puedes recuperar el valor comercial del vehículo, cumpliendo con lo estipulado en la póliza vehicular</li>
                                <li>•	En caso de un siniestro puedes requerir la reparación de daños a tu vehículo y al contar con el mejor seguro de auto cuentas con cobertura en base a las condiciones preferentes de tu póliza. </li>
                                <li>•	Ya no te preocupas de tener que renovar tu póliza anualmente ni tener que pagarla por un año en forma adelantada.</li>
                                <li>•	Evitas pagos de comisión por estudio y endosos</li>
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="33">
                            <Accordion.Header>
                              ¿Por qué tengo un seguro de desgravamen?
                            </Accordion.Header>
                            <Accordion.Body>
                              Es un seguro que cubre el pago de la deuda contraída con el fondo colectivo al que pertenezco, en caso de fallecimiento o invalidez total y permanente por accidente o enfermedad. Con ello, los herederos del asegurado se verán liberados de la obligación de pago del certificado.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="34">
                            <Accordion.Header>
                              ¿Cuál es el procedimiento en caso tenga un siniestro con mi vehículo?
                            </Accordion.Header>
                            <Accordion.Body>
                              Debes llamar a la Central de Atención de Emergencias de la Aseguradora con la que se contrató el seguro. Dicha central funciona las 24 horas los 365 días del año.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="35">
                            <Accordion.Header>
                              ¿Cuál es el procedimiento por seguir en caso de requerir aplicar al seguro de desgravamen?
                            </Accordion.Header>
                            <Accordion.Body>
                              Una vez ocurrido el siniestro, el familiar y/o contacto del cliente deberá realizar lo
                              siguiente:
                              <ul>
                                <li>•	Presentar una carta formal dirigida a Santander Empresa Administradora de Fondos Colectivos S.A. indicando lo ocurrido y solicitando la activación de Seguro de Desgravamen. Asimismo, consignar los datos de la persona de contacto.</li>
                                <li>•	Adjuntar a la carta una copia simple de la partida y/o acta de defunción.</li>
                                <li>•	Enviarla a través del formulario  <a
                                  href="/contactanos "
                                  className="linkturquesa "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Contáctanos                          </a>
                                  que se encuentra en nuestra página web.</li>
                                <li>•	Santander Fondos Colectivos entregará esta documentación al bróker, quienes se comunicarán con el contacto y solicitarán los siguientes documentos, según sea el caso.</li>
                              </ul>
                              Para FALLECIMIENTO POR CAUSA NATURAL:
                              <ul>
                                <li>•	Formulario de Declaración del Siniestro proporcionado por la Compañía.</li>
                                <li>•	Copia simple del Documento de Identidad del Asegurado, de contar con el mismo</li>
                                <li>•	Copia simple del Acta de Defunción del Asegurado.</li>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Certificado de Defunción del Asegurado.
                                </li>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Informe médico del médico tratante en caso de fallecimiento por Enfermedad.
                                </li>
                                <li>•	Historia Clínica completa, foliada y fedateada del Asegurado, cuando la compañía lo requiera.
                                </li>
                              </ul>
                              Para FALLECIMIENTO POR ACCIDENTE:
                              <br />Adicional a los Documentos Sustentatorios, antes indicados, para la Cobertura de
                              <br />Fallecimiento por Causa Natural, deberán presentar los siguientes documentos:
                              <ul>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Atestado Policial o Parte Policial, según corresponda.
                                </li>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del
                                  Protocolo de necropsia que incluya el resultado de examen toxicológico y
                                  dosaje etílico, en caso corresponda.
                                </li>
                              </ul>
                              Para INVALIDEZ TOTAL Y PERMANENTE POR ENFERMEDAD:
                              <ul>
                                <li>•	Formulario de Declaración del Siniestro proporcionado por la Compañía.</li>
                                <li>•	Copia simple del documento de identidad del Asegurado.</li>
                                <li>•	Historia Clínica completa foliada y fedateada del Asegurado, cuando la
                                  compañía lo requiera.
                                </li>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del
                                  Certificado de Invalidez Total y Permanente expedido por ESSALUD o la COMAFP (Comité Médico de las AFP) y/o COMEC (Comité Médico de la Superintendencia) o en su defecto por los hospitales nacionales bajo la gestión del MINSA o por el Instituto Nacional de Rehabilitación.
                                </li>
                              </ul>
                              Para INVALIDEZ TOTAL Y PERMANENTE POR ACCIDENTE:
                              <br /> Adicional a los Documentos Sustentatorios para la Cobertura de Invalidez Total y Permanente por Enfermedad, deberán presentar los siguientes documentos:

                              <ul>
                                <li>•	Original y/ certificación de reproducción notarial (copia legalizada) del</li>
                                <li>•	Atestado Policial o Parte Policial, según corresponda.</li>
                                <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del resultado de examen toxicológico y dosaje etílico, en caso corresponda.</li>
                              </ul>
                              En caso de Siniestros en el extranjero, los documentos deberán estar legalizados por el Consulado Peruano del país donde ocurrió el siniestro y validado por el Ministerio de Relaciones Exteriores de Perú; o de ser el caso, debidamente apostillados.
                              <br />En caso los documentos estén en idioma extranjero, deberán presentarse con traducción oficial y visado por el Ministerio de Relaciones Exteriores.

                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="36">
                            <Accordion.Header>
                              ¿Mi vehículo queda en garantía una vez Adjudicado?
                            </Accordion.Header>
                            <Accordion.Body>
                              Efectivamente, una vez que hayas firmado el Contrato de Garantía Mobiliaria y Escritura Pública, la garantía del vehículo quedará inscrito en el Registro Mobiliario de Contratos de la Superintendencia Nacional de Registros Públicos (SUNARP).
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="37">
                            <Accordion.Header>
                              ¿Qué sucede si no pago mis cuotas antes de la adjudicación?
                            </Accordion.Header>
                            <Accordion.Body>
                              La EAFC resolverá unilateralmente el Contrato ante el incumplimiento del Asociado en el pago de tres (03) Cuotas Total consecutivas y las cuotas impagas estarán afectas a la Compensación por pago tardío especificado en el Tarifario. Para más información ver el  <a
                                href="/contactanos "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contrato de Administración de Fondos Colectivos
                              </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="38">
                            <Accordion.Header>
                              ¿Qué sucede si no pago mis cuotas después de la adjudicación?
                            </Accordion.Header>
                            <Accordion.Body>
                              La EAFC resolverá unilateralmente el Contrato ante el incumplimiento del Asociado en el pago de tres (03) Cuotas Total consecutivas e iniciará el proceso de Incautación del Vehículo. Para más información ver el  <a
                                href="/contactanos "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contrato de Administración de Fondos Colectivos
                              </a>
                              y el  <a
                                href="/contactanos "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contrato de Garantía Mobiliaria                  </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="39">
                            <Accordion.Header>
                              ¿Qué quiere decir que me han Resuelto el Contrato?
                            </Accordion.Header>
                            <Accordion.Body>
                              Si se tratara de un Asociado no adjudicado, tendrá derecho a la devolución de las Cuotas Capital aportadas, deduciendo las penalidades pactadas en el Contrato. Para ello, participarán en sorteos trimestrales que les permitirán, de ser beneficiados, obtener la devolución. De lo contrario, la devolución se efectuará una vez que finalice el plazo del Grupo del que formó parte el Asociado con Contrato resuelto.
                              <br />Si se tratara de un Asociado con bien entregado y/o servicio prestado, la EAFC podrá dar por vencidos los plazos pactados en el Contrato y exigir el pago de las Cuotas Total devengadas y por devengar hasta la finalización del Contrato. La EAFC podrá ejecutar las garantías otorgadas por el Asociado, salvo que se haya contratado un seguro de incumplimiento y este cubra el total de lo adeudado.

                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="40">
                            <Accordion.Header>
                              ¿Qué penalidades existen si me resuelven el Contrato?
                            </Accordion.Header>
                            <Accordion.Body>
                              Son las que están claramente establecidas en el Contrato, incluyendo el monto al que ascenderá. Ninguna penalidad de manera individual podrá superar el monto equivalente a dos (02) Cuotas Capitales.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="41">
                            <Accordion.Header>
                              ¿Qué ocurre si pago mis cuotas con atraso?
                            </Accordion.Header>
                            <Accordion.Body>
                              Las cuotas impagas estarán afectas a la Compensación por pago tardío especificado en el Tarifario. Para más información ver el  <a
                                href="/contactanos "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contrato de Administración de Fondos Colectivos
                              </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="42">
                            <Accordion.Header>
                              ¿Cómo es el proceso de devolución de aportes?
                            </Accordion.Header>
                            <Accordion.Body>
                              Si se tratara de un Asociado no adjudicado, tendrá derecho a la devolución de las Cuotas Capital aportadas, deduciendo las penalidades pactadas en el Contrato. Para ello, participarán en sorteos trimestrales que les permitirán, de ser beneficiados, obtener la devolución. De lo contrario, la devolución se efectuará una vez que finalice el plazo del Grupo del que formó parte el Asociado con Contrato resuelto.
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="43">
                            <Accordion.Header>
                              ¿Dónde puedo consultar a la lista de Vendedores hábiles y aptos para ofrecer un Certificado de Compra?
                            </Accordion.Header>
                            <Accordion.Body>
                              Lo puedes revisar en nuestra web, en la sección de  <a
                                href="/transparencia "
                                className="linkturquesa "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Transparencia                 </a>
                              .
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item eventKey="44">
                            <Accordion.Header>
                              Tengo otras dudas. ¿A qué número puedo llamar?
                            </Accordion.Header>
                            <Accordion.Body>
                              Puedes llamar a nuestro número de Atención al Cliente (01) 730 - 1077.
                            </Accordion.Body>
                          </Accordion.Item>
                          <div className="section-information__tabs__link">
                            <div className="section-information__tabs__link__body" onClick={() => setFaqVisable(false)} >
                              <h6 >Ver menos preguntas</h6>
                              <span>
                                <img src="icons/safe/chevron-up-sm.svg" alt="Place Holder" />
                              </span>
                            </div>

                          </div>
                        </div>
                      )
                    }
                  </Accordion>
                </div>
              </Tab>
            </Tabs>
          </div>

        </div>
      </Container>


      <ModalPromotions
        title={titleModalPromotion}
        show={visibleModalPromotion}
        handleClose={handleModalPromotion}
        documents={documentsModalPromotion}
      />

    </div>
  );
}

export default PromotionHistory